import ActionKeys from '../actions/ActionKeys';

const initialState = {
    detail: null,
};

const initialStateCopy = {
    isCopy: false,
};

export const returnGoodsReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionKeys.RETURN_GOODS.GET_DETAIL:
            return {
                ...state,
                detail: action.data,
            };
        default:
            return state;
    }
};

export const isCopyReturnReducer = (state = initialStateCopy, action) => {
    switch (action.type) {
        case ActionKeys.RETURN_GOODS.IS_COPY:
            return {
                ...state,
                isCopy: action.data,
            };
        default:
            return state;
    }
};